const DEMO_FEEDBACK_OPEN_EVENT = 'open-demo-feedback';

export default function Footer() {
  const regionLinks = [
    { label: 'Panama City Beach', href: '/pcb-area-search' },
    { label: '30A', href: '/30a-area-search' },
    { label: 'Rosemary Beach', href: '/rosemary-beach-search' },
    { label: 'WaterSound', href: '/watersound' },
    { label: 'Dune Allen', href: '/dune-allen' },
    { label: 'Santa Rosa Beach', href: '/santa-rosa-beach' },
  ];

  return (
    <footer className="relative bg-secondary-950 text-secondary-100 pt-20 md:pt-28 pb-10">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          <div className="md:col-span-5">
            <img
              src="https://storage.helloreaddy.io/project_files/6010ef82-6c94-407b-9fac-7f3ca6010bf2/a9dda6ae-3ab1-4d64-b562-0b538ac1d564_compressed_inspire-CLASSY-WHITEOUT-WEB1.webp"
              alt="Inspire Vacation Properties"
              className="h-20 md:h-24 lg:h-28 w-auto"
              draggable={false}
            />
            <p className="mt-5 text-sm text-secondary-200/80 max-w-md leading-relaxed">
              A thoughtful collection of vacation properties along the Emerald Coast from Panama
              City Beach to 30A.
            </p>

            <a
              href="/#concierge"
              className="mt-8 inline-flex items-center gap-2 text-sm text-secondary-100 hover:text-background-50 cursor-pointer whitespace-nowrap"
            >
              Ask the Insider
              <i className="ri-arrow-right-up-line" />
            </a>
          </div>

          <div className="md:col-span-2">
            <p className="text-[11px] uppercase tracking-[0.22em] text-secondary-400 mb-4">Explore</p>
            <ul className="space-y-3 text-sm">
              {[
                { label: 'Our properties', href: '/vacation-search-results' },
                { label: 'The Inspire Insider', href: '/#concierge' },
                { label: 'Experiences', href: '/#experiences' },
                { label: 'Map Search', href: '/map-search' },
                { label: 'Join Our Rental Program', href: '/join-our-rental-program' },
                { label: 'Contact', href: '/#contact' },
              ].map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-secondary-100 hover:text-background-50 cursor-pointer">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-[11px] uppercase tracking-[0.22em] text-secondary-400 mb-4">Regions</p>
            <ul className="space-y-3 text-sm">
              {regionLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-secondary-100 hover:text-background-50 cursor-pointer">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.22em] text-secondary-400 mb-4">Get in touch</p>
            <div className="space-y-4 text-sm text-secondary-200/90">
              <p>Emerald Coast, Florida</p>
              <a
                href="mailto:AP@InspireVP.com"
                className="inline-flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-[#EFE4D6] text-foreground-950 hover:bg-[#E9DCCB] transition-colors cursor-pointer whitespace-nowrap"
              >
                Email us
                <i className="ri-mail-line" />
              </a>
              <p>
                <a href="tel:8508192764" className="hover:text-background-50 cursor-pointer">
                  850-819-2764
                </a>
              </p>
              <p>
                <a href="/#concierge" className="underline underline-offset-4 hover:text-background-50 cursor-pointer">
                  Ask the Insider
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-5 rounded-2xl border border-secondary-700 bg-secondary-900/70 p-5 sm:flex-row sm:items-center sm:justify-between sm:p-6">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-secondary-400">
              Reviewing this demo?
            </p>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-secondary-100">
              Walk through the site, tell us what you’d change, and send all your feedback at once.
            </p>
          </div>
          <button
            type="button"
            onClick={() => window.dispatchEvent(new CustomEvent(DEMO_FEEDBACK_OPEN_EVENT))}
            className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-[#EFE4D6] px-5 py-4 text-sm font-medium text-foreground-950 shadow-lg transition-colors hover:bg-[#E9DCCB] cursor-pointer"
          >
            <i className="ri-mic-line text-lg" />
            Record Demo Feedback
          </button>
        </div>

        <div className="mt-8 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-[11px] uppercase tracking-[0.2em] text-secondary-400">
          <span>© {new Date().getFullYear()} Inspire Vacation Properties</span>
          <a href="/accessibility-statement" className="hover:text-background-50 cursor-pointer">
            Accessibility Statement
          </a>
        </div>
        <p className="mt-2 text-[11px] text-secondary-500 max-w-xl leading-relaxed">
          Proudly Powered by{' '}
          <a
            href="https://maxnetdigital.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 hover:text-background-50 cursor-pointer"
          >
            MAXNET DIGITAL
          </a>
        </p>
      </div>
    </footer>
  );
}
